// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"SupplierMasterPage_headerActions__3GliT"};